module.exports = __webpack_public_path__ + "img/vue-crud-sm.5e3bc595.png";